import { createEntityQueryKeys } from '@/shared/lib'

/**
 * `detail(token)` rather than `detail(id)`: the token is what addresses a subscription, and
 * the visitor holding one is signed out, so there is no id to key on.
 */
export const subscriptionKeys = createEntityQueryKeys(['subscriptions'])
